const initialStateType = {
  types: {},
  types_updated: false,
};

export default initialStateType;